module.exports = __webpack_public_path__ + "img/jorge.e300321e.png";